import React from 'react';
import PropTypes from 'prop-types';

import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import Placeholder from 'components/consumer/Placeholder';
import CtaButton from 'components/essentials/Cta/CtaButton';
import BrowserOnly from 'components/consumer/BrowserOnly';
import avo from 'analytics/avo';

const PDPFinancingUI = ({
  affirmButtonRef,
  loading,
  numberOfMonths,
  onFinancingClick,
  pdpIsModularBYOProduct = false,
  perMonthAmount,
  price,
  showLearnMore = false,
}) => {
  const currentPage = useUserCurrentPageType();

  const financingLearnMoreOnClick = () => {
    avo.ctaClicked({
      text: 'Learn more',
      targetUrl: 'modal',
      cta: avo.Cta.FINANCING,
      component: avo.Component.PRODUCT_CARD,
      location: currentPage,
    });
    onFinancingClick();
  };

  if (loading) {
    return (
      <div className="flex mt-1 lg:mt-1.5 !w-full lg:!w-[310px]">
        <Placeholder
          type="rect"
          loading
          className="rounded-sm min-h-[12px]"
          style={{
            height: '23px',
            marginRight: '0',
          }}
        />
      </div>
    );
  }

  return (
    <div className="flex mt-1 lg:mt-1.5 min-w-max">
      {pdpIsModularBYOProduct && !price ? (
        <span className="text-xs flex text-gray mt-0 mr-2 mb-0 ml-0 whitespace-nowrap">
          Start adding pieces to calculate price + financing options
        </span>
      ) : (
        <BrowserOnly>
          <span className="text-xs flex text-gray mt-0 mr-2 mb-0 ml-0 whitespace-nowrap">
            {`From $${perMonthAmount}/mo for ${numberOfMonths} months at 0% APR `}
          </span>

          {showLearnMore && (
            <CtaButton
              className="hover:underline"
              onClick={financingLearnMoreOnClick}
              styling="link"
              color="brand"
              hasArrow={false}
              noLinkPadding
              type="button"
              size="xs"
              aria-label="Learn more about monthly payments"
            >
              Learn more
            </CtaButton>
          )}

          <div style={{ display: 'none' }}>
            <div
              type="button"
              ref={affirmButtonRef}
              className="affirm-as-low-as"
              data-page-type="product"
              data-amount={(price * 100).toString()}
            >
              Apply Now
            </div>
          </div>
        </BrowserOnly>
      )}
    </div>
  );
};

PDPFinancingUI.propTypes = {
  affirmButtonRef: PropTypes.object,
  loading: PropTypes.bool,
  numberOfMonths: PropTypes.number,
  onFinancingClick: PropTypes.func,
  pdpIsModularBYOProduct: PropTypes.bool,
  perMonthAmount: PropTypes.number,
  price: PropTypes.number,
  showLearnMore: PropTypes.bool,
};

export default PDPFinancingUI;
